import BFLButton from "@repo/shared-ui/BFLButton";
import { FC } from "react";

interface TrredingStockCardFooterProps {
  date: string;
  time: string;
  buyText: string;
  sellText: string;
  onBuyClick: () => void;
  onSellClick: () => void;
}

const TredingStockCardFooter: FC<TrredingStockCardFooterProps> = ({
  date,
  time,
  buyText,
  sellText,
  onBuyClick,
  onSellClick,
}) => (
  <div className="mt-3 flex items-center justify-between border-t border-[#E5E5E5] pt-3">
    <div className="flex items-center text-[12px] md:text-sm font-normal text-[#1A1A1A]">
      <span>{date}</span>
      <span className="mx-2" aria-hidden="true">
        •
      </span>
      <span>{time}</span>
    </div>
    <div className="flex items-center gap-2">
      <BFLButton
        className="rounded-[200px] bg-[#089E86] px-[12px] py-[4px] md:px-[24px] md:py-[12px] text-[12px] md:text-sm font-medium text-white transition-colors hover:bg-[#067161] leading-4 md:leading-[18px]"
        onClick={onBuyClick}
      >
        {buyText}
      </BFLButton>
      <BFLButton
        className="rounded-[200px] bg-[#E55005] px-[12px] py-[4px] md:px-[24px] md:py-[12px] text-[12px] md:text-sm font-medium text-white transition-colors hover:bg-[#c74c1a] leading-4 md:leading-[18px]"
        onClick={onSellClick}
      >
        {sellText}
      </BFLButton>
    </div>
  </div>
);

export default TredingStockCardFooter;
